import { render, staticRenderFns } from "./HomeworkContentDialog.vue?vue&type=template&id=33e2c258&scoped=true"
import script from "./HomeworkContentDialog.vue?vue&type=script&lang=js"
export * from "./HomeworkContentDialog.vue?vue&type=script&lang=js"
import style0 from "./HomeworkContentDialog.vue?vue&type=style&index=0&id=33e2c258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2c258",
  null
  
)

export default component.exports